import { IDynamicFormWidgetSection } from '@components/dynamic-form/types';
import { FormFieldType } from '@components/dynamic-form/types/inputTypes';
import { IAbstractRecord } from '@models';
import { IAmendmentGeneralData } from '@modules/production/amendment-details/line-amendment';
import PrecisionService from '@services/PrecisionService';

export const getCostChargesInputs = (
  values: IAbstractRecord,
  lineExternalCode: string
): IDynamicFormWidgetSection[] => {
  return [
    {
      inputs: {
        policyCostVariance: {
          name: 'policyCostVariance',
          title: 'Policy Cost Variance',
          type: FormFieldType.currency,
          placeholder: 'Policy Cost Variance',
          value: values?.amendmentPOVariance_AmendmentCostAmount ?? '',
          required: true,
          allowNegative: true,
        },
        chargesVariance: {
          name: 'chargesVariance',
          title: 'Charges Variance',
          type: FormFieldType.percentage,
          placeholder: 'Charges Variance',
          value:
            PrecisionService.multiplyBy100(
              values?.amendmentPOVariance_AmendmentChargesPercentage
            ) ?? '',
          required: true,
        },
        tpaFeesVariance: {
          name: 'tpaFeesVariance',
          title: 'TPA Fees Variance',
          type: FormFieldType.currency,
          placeholder: 'TPA Fees Variance',
          value: values?.amendmentPOVariance_AmendmentTPAFeesAmount ?? '',
          required: true,
          allowNegative: true,
          hidden: ['19', '48'].includes(lineExternalCode),
        },
      },
    },
  ];
};
